/* eslint-disable  */
import React, { useState, useMemo} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useTitle } from '~/titles';
import { DataGrid } from '@mui/x-data-grid';
import { Grid, Typography, Button, Dialog, DialogTitle, DialogContent, IconButton, Menu, MenuItem } from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import Form from '@/eval-questions/Form';
import Swal from '#/swal';
import { useDeleteEvalQuestion } from '~/evals';




const useStyles = makeStyles({
    dataGrid: {
        '&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus, &.MuiDataGrid-root .MuiDataGrid-cell:focus': {
            outline: 'none'
        }
    },
    tableWrapper: {
        width: '100%'
    },
    redButton: {
        color: '#fff',
        backgroundColor: '#DB2828'
    }
});

const EvalQuestionList = props => {

    //Defining Styles
        const classes = useStyles();

    //specific title data passed through the url
        const title_id = props.match.params.title_id

    //Title Data
        const { data: title, isLoading } = useTitle(title_id);

    //Delete Eval Question
        const { mutate: deleteEvalQuestion } = useDeleteEvalQuestion()

    //handling state changes for the row and actions button      
        const [rowSelected, setRowSelected]=useState();
        const [actions, setActions] = useState(null);

    //Dialog state for "Edit" button
       const [editModalOpen, setEditModalOpen] = useState(false);

    //Dialog state for "new Question" button 
        const [modalOpen, setModalOpen] = useState(false);

    //Handle to open "New Question" dialog
        const handleClickOpen = () => {
            setInitialValues(null);
            setModalOpen(true);
            
        }

     // for Edit employee form 
        const [initialValues, setInitialValues] = useState({ title_id });

    // Handle to delete Job Title
        const handleDelete = async rowSelected => {
            const { value } = await Swal.fire.warning({ text: `Are you sure you want to delete this question?` });
    
            if (value) {
                deleteEvalQuestion(rowSelected.id)
            }
    
        };

    
    // // defining evalQuestion
    //     const evalQuestion = (question) => {
    //         question?.eval_questions[0]
    //     }
    
        // Popover settings.
        const openPopover = (event, row) => {
            // console.log("????", row)
            setRowSelected(row)
            setActions(event.currentTarget);
            };
        const closePopover = () => {
            setActions(null);
            };
        const moreActions = Boolean(actions);

        const onSubmit = values => {
            if (initialValues) {
                setInitialValues({title_id: values.id})
            }
        }
    //setup for questions table
        const columns = useMemo(() => [

        //setup question column
            {
                field:'questions',
                renderHeader: () => <strong>Question</strong>,
                renderCell: ({ row }) => {
                    return <div>{row.question_descriptor}</div>
                },
                flex: 0.7
            },
        //Setup descriptor column
            {
                field:'descriptors',
                renderHeader: () => <strong>Descriptor</strong>,
                renderCell: ({ row }) => {
                    return <div
                        style={{
                            whiteSpace:'normal',
                            lineHeight:'normal'
                        }}
                    >{row.question_text}</div>
                },
                flex: 1
            },

        //setup for actions column & adding a edit button to each row
            {
                field: 'Actions',
                align: 'right',
                headerAlign: 'right',
                renderHeader: () => <strong>Actions</strong>,
                renderCell: ({ row }) => (
                    <div>
                        <IconButton onClick= {(e) => openPopover(e, row)}>
                            <MoreVert />
                        </IconButton>
                    </div>
                ),
                flex: .2
            }

        ], []);


    return (

        <div>
            <Grid container justifyContent='space-between' style={{ marginBottom: '20px', marginTop: '20px' }}>
                <Grid item>
                    <Typography variant='h4' children={(title?.name)+' Evaluation Questions'}/>
                </Grid>

                <Grid item>
                    <Button
                    children='New Question'
                    variant='contained'
                    color='primary'
                    onClick={handleClickOpen}
                    />
                    <Dialog>
                        <DialogTitle content={`New Question`}/>
                    </Dialog>
                </Grid>
            </Grid>

            <div className={classes.tableWrapper}>
                <DataGrid
                    className={classes.dataGrid}
                    //loading={isLoading}
                    columns={columns}
                    rows={title?.eval_questions || []}
                    autoHeight
                    disableSelectionOnClick
                    hideFooterSelectedRowCount
                />

                <div>
                    <Menu
                        id='actions'
                        open={moreActions}
                        anchorEl={actions}
                        onClose={closePopover}
                        onClickCapture={closePopover}
                        >
                        <MenuItem onClick={() => {
                            // console.log(rowSelected, 'yte')
                            setInitialValues(rowSelected);
                            setModalOpen(true);
                        }}>
                            Edit
                        </MenuItem>
                        <MenuItem 
                        onClick={() => handleDelete(rowSelected)}
                        >
                            Delete
                        </MenuItem>
                    </Menu>
                </div>
            </div>

            <Dialog open={modalOpen} onClose={() => setModalOpen(false)}>
                <DialogContent>
                    <Form setModalOpen={setModalOpen} initialValues={initialValues} onSubmit={onSubmit} title={title}/>
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default EvalQuestionList;